import { get, isArray } from 'lodash';
import { array, bool, func, object, oneOfType, string } from 'prop-types';
import { useState } from 'react';

import {
  getReactSelectMultipleValues,
  getReactSelectValue,
  ReactSelectInput,
} from '@hivebrite/design-system/Inputs';

import { SelectWrapper } from 'hb-builder/components/common/SettingsLibrary/CommonSettings/styles/SelectWrapper';

interface SelectSettingProps {
  disabled?: boolean;
  fallbackValue?: string;
  isLoading?: boolean;
  isMulti?: boolean;
  item: any;
  options: { label: string; value: string | number }[];
  onChange: (value: any) => void;
  placeholder?: string;
  settingKey: string;
  title?: string;
}

const SelectSetting = ({
  disabled = false,
  fallbackValue,
  isLoading = false,
  isMulti,
  item,
  options,
  onChange,
  placeholder,
  settingKey,
  title,
}: SelectSettingProps) => {
  const [value, setValue] = useState(
    get(item.attributes, settingKey, fallbackValue),
  );

  const handleChange = (e) => {
    const finalValue = isMulti ? e : e.value;

    setValue(finalValue);

    onChange({
      id: item.id,
      settingKey: `attributes.${settingKey}`,
      value: finalValue,
    });
  };

  const valueSelected = isMulti
    ? getReactSelectMultipleValues(
        options,
        value?.map(({ value }) => value),
      )
    : getReactSelectValue(options, value);

  return (
    <SelectWrapper>
      <ReactSelectInput
        disabled={disabled}
        id="settingsSelect"
        isLoading={isLoading}
        label={title}
        name="settingsSelect"
        onChange={handleChange}
        options={options}
        placeholder={
          isMulti || isArray(valueSelected) ? placeholder : valueSelected?.label
        }
        value={value !== 'empty' ? valueSelected : ''}
        width="100%"
        isMulti={isMulti}
      />
    </SelectWrapper>
  );
};

export default SelectSetting;

SelectSetting.defaultProps = {
  isMulti: false,
  placeholder: '',
};

SelectSetting.propTypes = {
  item: object.isRequired,
  onChange: func.isRequired,
  options: array.isRequired,
  settingKey: string.isRequired,
  placeholder: string,
  title: oneOfType([string, object]),
  isMulti: bool,
};
